export default __webpack_public_path__ + "static/media/Christmas arrangment_primary.a22acbf8.jpg";